
























































import { defineComponent, PropType, ref } from '@vue/composition-api';
import { PublicationResponse } from '@oare/types';

export default defineComponent({
  name: 'CollectionsList',
  props: {
    publications: {
      type: Array as PropType<PublicationResponse[]>,
      required: true,
    },
  },
  setup() {
    const nonPubInfo = ref(false);
    return {
      nonPubInfo,
    };
  },
});
